import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { TargetListInfo } from '../vo/target_list_info.model';

// レスポンス構造
type GetGoodsPlanNum = {
  Pcode: string;
  PlanNumAiPrediction: string;
}[];

interface GetGoodsPlanNumResponse {
  "PlanNumList": GetGoodsPlanNum
}[]; 



/**
 * 商品計画数予測取得サービス
 * @export GetGoodsPlanNumService
 * @class GetGoodsPlanNumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsPlanNumService extends PlessJsonResponderSub<GetGoodsPlanNumResponse> {
  model: KYMW7001Model;
  checkTargetListInfo: TargetListInfo[];
  private calbak: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGoodsPlanNumResponse
   */
  private successFunc: (model: any) => void;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsPlanNumService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      GetGoodsPlanNum: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
        },
        combination: this.checkTargetListInfo.map(item => ({
          parameter: {
            PCode: item.pCode
          }  
        }))
      }
    };

    return new PlessRequest({ search: searchObj});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsPlanNumService
   */
  execute(model: KYMW7001Model, checkTargetListInfo: TargetListInfo[], f: (model: any) => void): void {
    this.model = model;
    this.checkTargetListInfo = checkTargetListInfo;
    if (f) this.calbak = f;
    this.send('KYMW70getGoodsPlanNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsPlanNumService
   */
  success(data: GetGoodsPlanNumResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
